import React, { useEffect } from 'react';
import { listsViewStyles } from '../styles';
import { FormControl, Grid, TextField, Typography, withStyles } from '@material-ui/core';

function ListTab({ classes, register, formValues, setFormValues, fieldName, defaultValues }) {
    const defaultText = defaultValues ? defaultValues.join('\n') : '';

    const currentValue = formValues[fieldName];
    useEffect(() => {
        if (defaultText && !currentValue) {
            setFormValues(prev => ({
                ...prev,
                [fieldName]: defaultText
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentValue, fieldName, defaultText]);

    return (
        <Grid container direction="row" spacing={4}>
            <Grid item xs={12}>
                <Typography style={{ fontSize: 16 }}>
                    Add each list item in the textbox with each item on Its own line. Put them in the order you wish
                    them to appear.
                </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                <FormControl class={classes.textBox}>
                    <TextField
                        multiline
                        rows={8}
                        name={fieldName}
                        id={fieldName}
                        value={formValues[fieldName] || defaultText}
                        inputRef={register()}
                        onChange={({ target }) => {
                            setFormValues({
                                ...formValues,
                                [fieldName]: target.value
                            });
                        }}
                    />
                </FormControl>
            </Grid>
        </Grid>
    );
}

export default withStyles(listsViewStyles)(ListTab);
